function toNumberOnly(value) {
  if (value) {
    return value.replace(/\D/g, '');
  }
  return '';
}

export { toNumberOnly };
